import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { ColorBlock } from "@/ui/ColorBlock";
const styles = {
  block: {
    kzqmXN: "xh8yej3",
    ks0D6T: "x7ep2pv",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1rzw5jd",
    $$css: true
  }
};
export function WeatherBlock({
  children
}: {
  children: ReactNode;
}) {
  return <div className="x1us19tq xrvj5dj x1ku5rj1">
      <ColorBlock tone={3} padding="clamp(28px, 3.2vw, 48px)" xstyle={styles.block}>
        {children}
      </ColorBlock>
    </div>;
}